export default __webpack_public_path__ + "6da2ace65958272289b0395e17f874cf.png";